import script from "./Exemption.vue?vue&type=script&setup=true&lang=js"
export * from "./Exemption.vue?vue&type=script&setup=true&lang=js"

import "./Exemption.vue?vue&type=style&index=0&id=2c7a74fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c7a74fc"]])

export default __exports__